// node_modules
import { FC } from "react";
// Custom hooks
import { useFetch } from "Hooks";
// Components
import { AsynchronousWrapper, Label, MarkdownItComponent } from "Components";
// Types
import { TTechnologyHighlightsGroupsDTO, TUseFetch } from "Types";
// styles
import styles from "./technologyHighlightsPreview.module.scss";

type TTechnologyHighlightsPreviewProps = {
    technologyId: number,
    amount: number,
    onMoreButtonClick?: () => void
};

export const TechnologyHighlightsPreview: FC<TTechnologyHighlightsPreviewProps> = ({ technologyId, amount, onMoreButtonClick }: TTechnologyHighlightsPreviewProps) => {

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TTechnologyHighlightsGroupsDTO>
        = useFetch(`api/technologies/${technologyId}/highlights`);
    let index = 0;
    let hasMoreHighlights = false;

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            {fetchedData && fetchedData.scoutTechnologyHighlightsGroups && fetchedData.scoutTechnologyHighlightsGroups.length >= 1 ?
                <div>
                    <h5>Highlights</h5>
                    {
                        fetchedData.scoutTechnologyHighlightsGroups.map((techHighGroup, groupIndex) => {
                            if(groupIndex === 0) index = 0;

                            return (
                                techHighGroup.highlights.map((highlight) => {
                                    

                                    if (index >= amount) {
                                        hasMoreHighlights = true;
                                        return null;
                                    }
                                    index += 1;

                                    return (
                                        <div key={highlight.id} className={styles.technologyHighlight}>
                                            <Label text={techHighGroup.name} />
                                            <MarkdownItComponent 
                                                key={highlight.id} 
                                                source={highlight.description}
                                                env={technologyId ? { "technologyId": technologyId } : undefined} />
                                    </div>);
                                })
                            );
                        })
                    }
                    { onMoreButtonClick && hasMoreHighlights &&
                        <button onClick={onMoreButtonClick} className={styles.readMoreButton}>...READ MORE HIGHLIGHTS</button>
                    }
                </div>
                : <></>}
        </AsynchronousWrapper>
    );
};